export const GET_PENALTY= '/get_penalty';
export const GET_SINGLE_PENALTY= '/get_single_penalty';
export const UPDATE_PENALTY= '/update_penalty';
export const CREATE_PENALTY= '/create_penalty';
export const REMOVE_PENALTY= '/remove_penalty';
export const GET_ORDINANCE_REVISION = 'rate/get_ordinance_revision_list';

export const FORM_DATA = {
  name: '',
  description: '',
  surcharge: '',
  max_surcharge: '',
  ordinance_revision_id: '',
};